import { WithCSSVar } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'

export const extractInputPlaceholderStyle = (
    theme: WithCSSVar<Dict>,
): { color: string } => {
    return theme.components.Input.baseStyle({ theme }).field._placeholder
}
